export const setPrivList = (state, payload) => {    
	state.privList = payload;
}

export const setObjPrivEdit = (state, payload) => {
	var privId = payload.id;
	for( var k in state.privList ) {
		if( state.privList[k].id === privId ) {			
			state.objPrivEdit = state.privList[k];
		}
	}
}

export const setRunAdd = (state, payload) => {
	state.runAdd = payload;
}
